<template>
  <el-drawer title="我是标题" custom-class="My-Community" :destroy-on-close="true" size="35%" :modal="false"
    :append-to-body="true" :visible.sync="communityDrawer" direction="rtl">
    <div class="Top">
      <div class="T-Left">
        <span>{{ community.nameCn }}</span>
        <span>{{ community.nameEn }}</span>
      </div>
      <div class="T-Right">
        <i class="el-icon-close" @click="communityDrawer = false"></i>
      </div>
    </div>
    <div class="Right-End Right-Padding">
      <span><svg-icon class="icon-class" iconClass="question"></svg-icon>提问题</span>
      <span><svg-icon class="icon-class" iconClass="pingjia"></svg-icon>写评价</span>
      <span><svg-icon class="icon-class" iconClass="xunjia"></svg-icon>发询价</span>
    </div>
    <ueditor ref="ueditor" class="myUeditor" v-if="community.productType == 1" :readonly="true"></ueditor>
    <hotelDetail v-else-if="community.state == 0" :community="community" :checkBudgets="checkBudgets"></hotelDetail>
    <spotDetail v-else-if="community.state == 2" :community="community" :checkBudgets="checkBudgets"></spotDetail>
    <siteFiyloDetail v-else-if="community.state == 1" :community="community" :checkBudgets="checkBudgets">
    </siteFiyloDetail>
  </el-drawer>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import hotelDetail from '@/views/plan/info/child/hotelDetail.vue'
import spotDetail from './child/spotDetail.vue'
import siteFiyloDetail from './child/siteFiyloDetail.vue';
import Api from "@/components/Api";
import Ueditor from '../../../components/Editor/Ueditor.vue';
export default {
  name: '',
  components: {
    hotelDetail,
    spotDetail,
    siteFiyloDetail,
    Ueditor
  },
  // 定义属性
  data() {
    return {
      community: "",
      communityDrawer: false,
      checkBudgets: ""
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    init(community,productType = -1) {
      this.communityDrawer = true
      let resourceInfoRequest = {
        productType: community.productType || productType,
        rid: community.id,
        state: community.state
      }
      if (community.state === 1) {
        let obj = JSON.parse(JSON.stringify(community))
        obj.thirdData = JSON.parse(obj.thirdData)
        obj.pictures = obj.thirdData.picList.map((url, index) => ({
          name: `会议${index + 1}`,
          path: url,
        }));
        obj.otherResourceData = {
          brandName:'会场',
        }
        this.community = obj
      } else {
        new Api("resource").resourceInfo(resourceInfoRequest).then(res => {
          if (res.status === 200) {
            if(res.data.state==0&&res.data.otherResourceData.facCheck&&res.data.otherResourceData.facCheck!=''){
              this.$set(res.data.otherResourceData,'facCheck',JSON.parse(res.data.otherResourceData.facCheck))
            }
            this.community = res.data
            this.community.state = community.state
            if (community.productType == 1) {
              this.$nextTick(() => {
                this.$refs.ueditor.setUeContent(this.community.introduction)
              })
            }
          }
        })
      }
    },
    close() {
      this.communityDrawer = false
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.My-Community>.el-drawer__header {
  display: none;
}

.My-Community>.el-drawer__body {
  overflow: hidden;
}
</style>
<style scoped lang="scss">
.myUeditor {
  top: 4px;

  /deep/ .edui-editor-toolbarbox {
    display: none;
  }

  /deep/.edui-editor {
    border: none;
  }

  /deep/.edui-editor-bottomContainer {
    display: none;
  }
}

.Right-End {
  display: flex;
  margin: 10px 0 10px 20px;

  >span {
    margin-right: 10px;
    display: flex;
    color: #02A0C6;
    font-size: 0.12rem;
    font-weight: 400;

    >svg {
      height: 14px;
      width: 14px;
      margin-right: 5px;
    }
  }
}

/deep/ .el-drawer__container {
  height: 98%;
  top: 50%;
  transform: translateY(-50%);
}

.el-drawer__wrapper {
  right: 10px;
}

.el-drawer__body {
  overflow: hidden;
}

.Top {
  background: #fbfbfb;
  height: 50px;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;

  .T-Left {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;

    >span:nth-child(1) {
      font-size: 16px;
      color: #333;
      font-weight: 700;
    }

    >span:nth-child(2) {
      font-size: 12px;
      color: #333;
      font-weight: 700;
    }
  }

  .T-Right {
    width: 50px;
    height: 50px;
    border-left: 1px solid #ddd;

    >i {
      font-size: 25px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>